import MarkdownCopy from '@components/cms/Slices/MarkdownCopy';
import cn from 'classnames';
import Heading from '@components/ui/Heading';
import Container from '../Container';

import styles from './SeoContentComponent.module.scss';

export interface SeoContentData {
  title?: string | null;
  title_position?: string | null;
  body?: string | null;
  htmlBody?: string | null;
  body1?: {
    text: string;
  }[];
}

export interface SeoContentComponentProps {
  data?: SeoContentData;
}

const SeoContentComponent = ({ data }: SeoContentComponentProps) => {
  const body = data?.body || data?.body1?.[0]?.text;

  return (
    <section className={styles.container}>
      <Container>
        {data?.title && (
          <Heading
            semanticLevel="h2"
            styleLevel="2"
            children={data?.title}
            className={cn(styles.heading, {
              [styles.left]: data?.title_position === 'left',
            })}
          ></Heading>
        )}
        {body && <MarkdownCopy text={body} className={styles.body} />}
        {data?.htmlBody && (
          <div
            className={styles.body}
            dangerouslySetInnerHTML={{ __html: data.htmlBody }}
          />
        )}
      </Container>
    </section>
  );
};
export default SeoContentComponent;
